import React, { Component } from 'react';
import { Button, RadioButtonGroup, RadioButton, Notification } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { Breadcrumb } from '../../../../components';
import { getByDmService, insertDmService, getDmService, updateDmService } from '../../../../services/Api';
import { SelectedProducts, SizeQuantity } from '../../../../components/agency/requests';
import KitProducts from '../../../../components/agency/requests/KitProducts';
import BriefingRequestProduct from '../../../../components/agency/requests/BriefingRequestProduct';
import UploadReference from '../../../../components/agency/requests/UploadReference';
import { Administrador, Consultor, Criacao, Interno, Supervisor } from '../../../../config/UserStatusLevel';
import { Devolvido, Triagem } from '../../../../config/StatusPedido';
// import { create } from 'lodash';
class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
      dataProduct: {},
      disabledButtonCart: false,
      calcPrice: "",
      finalPrice: 0,
      dataRequest: {},
      listRequest: [],
      isCarrinho: true,
      sizeOK: true,
      pendingStep: false,
      pendingStepBriefing: false,
      isKit: false,
      createText: null,
      excluido: false
    }
  }

  componentDidMount = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel, createText: null });
    // REMOVIDO: A lógica de isFinished e visibilidade será passada via prop para o componente renderizado.
    await this.getItemsRequest()
    await this.implementListSizes()
  }

  componentDidUpdate(prevProps, prevState) { // Adicionado prevState para comparar o estado corretamente
    // Pegamos os produtos do estado atual e anterior
    const currentProduct = this.state.product;
    const prevProduct = prevState.product;

    let productChanged = false;
    if (currentProduct && prevProduct) {
      if (currentProduct.tipoUso !== prevProduct.tipoUso) {
        productChanged = true;
      }
    } else if (currentProduct && !prevProduct) {
      productChanged = true;
    } else if (!currentProduct && prevProduct) {
      productChanged = true;
    }

    // Se o produto mudou, re-inicializa o listSizes no dataProduct
    if (productChanged) {
      this.initializeDataProductListSizes(currentProduct);
    }
  }

  // NOVA FUNÇÃO: Para inicializar dataProduct.listSizes com base no tipoUso do produto
  initializeDataProductListSizes = (product) => {
    let initialListSizes = [];
    if (product && product.tipoUso && product.tipoUso.includes("Texto")) {
      initialListSizes = [{ texto: '' }]; // Para produtos de texto, inicializa com um briefing vazio
    }
    // Para outros tipos, pode ser um array vazio, SizeQuantity irá preencher

    this.setState(prevState => ({
      dataProduct: {
        ...prevState.dataProduct,
        listSizes: initialListSizes, // Garante que listSizes sempre existe
      },
      // Resetar outros estados relacionados a passos se necessário
      pendingStep: false,
      pendingStepBriefing: false,
    }));
  }

  getItemsRequest = async () => {
    const { match } = this.props;
    const { path, params } = match
    if (path === "/agencia/pedido/:id") {
      try {
        const dataRequest = await getDmService(`/Pedido/GetDetalheItemPedidoAgencia/${params.id}`);
        const { idGrupo, idProduto, idMaterial, idDetalhe, idItem } = await dataRequest
        const dataFilters = await getDmService(`/ProdutoAgencia/Busca/?IdGrupo=${idGrupo}&IdDescricao=${idProduto}&IdMaterial=${idMaterial}&IdDetalhe=${idDetalhe}&IdItem=${idItem}`);

        // Assumindo que dataFilters é o objeto do produto ou que dataRequest tem um 'product'
        const productFromRequest = dataFilters; // Ou dataRequest.product, dependendo da sua API

        let initialListSizes = [];
        if (productFromRequest && productFromRequest.tipoUso && productFromRequest.tipoUso.includes("Texto")) {
          // Se for um produto de texto, usa o texto existente ou inicializa vazio
          initialListSizes = [{ texto: dataRequest.detalhes && dataRequest.detalhes.length > 0 ? dataRequest.detalhes[0].texto : '' }];
        } else if (dataRequest.detalhes && dataRequest.detalhes.length > 0) {
          // Para outros tipos, se houver detalhes no pedido, mapeia para listSizes
          initialListSizes = dataRequest.detalhes.map(detail => ({
            // Mapeie as propriedades do 'detail' para a estrutura esperada por SizeQuantity
            // Exemplo:
            quantityPerModel: detail.quantidade,
            sizesInputed: detail.tamanhos ? detail.tamanhos.map(t => ({ widthProp: t.largura, heightProp: t.altura })) : [],
            sumSizes: this.sumValues(detail.tamanhos || []), // Certifique-se de que sumValues lida com array vazio
            value: detail.nomeProduto || '', // Ou outra propriedade relevante
            texto: detail.texto || '' // Se o detalhe também puder ter texto
          }));
        }

        const obj = {
          dataRequest,
          product: productFromRequest, // Garante que 'product' no estado é o objeto completo
          dataProduct: {
            dataFilters, // Mantém dataFilters aqui
            listSizes: initialListSizes, // Inicializa listSizes com base no pedido existente
          },
          isCarrinho: dataRequest.idStatusPedido === 1,
          idStatusPedido: dataRequest.idStatusPedido,
          excluido: dataRequest.excluido
        }
        await this.setState(obj);
      } catch (error) {
        console.log(error);
      }
    } else {
      this.loadProduct(); // Chama loadProduct para novos produtos
    }
  }

  componentWillReceiveProps(nextProps) {
    const { match } = this.props;
    const { dataRequest } = this.state;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    console.log('dataRequest');
    console.log(dataRequest);
    if (!existRequest) {
      if (nextProps.match.params.id !== match.params.id) {
        this.loadProduct(nextProps.match.params.id);
        // this.getProductsType(nextProps.match.params.id); // Comentado
        this.setState({ dataProduct: { listSizes: [] }, calcPrice: " " }) // Garante listSizes vazio aqui também
      }
    }
  }

  getSum = (total, num) => parseFloat(total) + parseFloat(num);

  sumValues = values => {
    // Adiciona verificação para 'values' ser um array
    if (!Array.isArray(values) || values.length === 0) {
      return { widthProp: 0, heightProp: 0 }; // Retorna um objeto padrão se não houver valores
    }
    const larg = values.map(item => (item.largura || 0)); // Garante que item.largura é um número
    const stature = values.map(item => (item.altura || 0)); // Garante que item.altura é um número
    const largValue = larg.reduce(this.getSum, 0);
    const statureValue = stature.sort((a, b) => b - a)[0];
    const objSum = { widthProp: largValue, heightProp: statureValue };
    return objSum;
  }

  implementListSizes = async () => {
    const { dataRequest, dataProduct } = this.state;
    const { localAplicacao, variaveisAplicacao } = dataRequest
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    if (existRequest) {
      const { detalhes } = dataRequest;
      // Esta lógica já deve estar coberta por getItemsRequest, mas se for um fluxo separado,
      // precisa garantir que listRequest seja mapeado para a estrutura de listSizes
      const listRequest = detalhes.map((item, index) => ({
        id: index,
        quantityPerModel: item.quantidade,
        sizesInputed: item.tamanhos.map(obj => ({
          widthProp: obj.largura,
          heightProp: obj.altura
        })),
        sumSizes: this.sumValues(item.tamanhos),
        value: `Nome do produto ${index}`,
        texto: item.texto || '' // Garante que texto está presente
      }))
      if (listRequest.length) {
        this.setState(prevState => ({
          listRequest,
          dataProduct: {
            ...prevState.dataProduct,
            listSizes: listRequest // Atualiza listSizes no dataProduct
          }
        }))
      }
      try {
        const dataApp = await getByDmService(`/Aplicacao`, localAplicacao);
        const listVariables = []
        if (dataApp.fracionado) {
          await listVariables.push({
            label: "Fracionado",
            value: "fracionado"
          })
        }
        if (dataApp.unico) {
          await listVariables.push({
            label: "Único",
            value: "unico"
          })
        }
        if (dataApp.sequencial) {
          await listVariables.push({
            label: "Sequencial",
            value: "sequencial"
          })
        }
        if (dataApp.preDefinido) {
          await listVariables.push({
            label: "Pré-definido",
            value: "preDefinido"
          })
        }
        if (dataApp.texto) {
          await listVariables.push({
            label: "Texto",
            value: "texto"
          })
        }
        this.setState(prevState => ({
          dataProduct: {
            ...prevState.dataProduct,
            listVariables
          }
        }))
      } catch (error) {
        console.log(error);
      }
    }
  }

  loadProduct = async (id) => {
    const { match } = this.props;
    const productId = id || match.params.id; // Usa o ID passado ou do match.params

    if (!productId) {
      // Se não há ID, limpa o produto e dataProduct
      this.setState({
        product: {},
        dataProduct: { listSizes: [] }, // Garante listSizes vazio
        calcPrice: "",
        // ... outros resets
      });
      return;
    }

    try {
      const productData = await getDmService(`/ProdutoCategoria/${productId}`); // Busca o produto
      this.setState(prevState => {
        let initialListSizes = [];
        if (productData && productData.tipoUso && productData.tipoUso.includes("Texto")) {
          initialListSizes = [{ texto: '' }]; // Para novos produtos de texto
        }
        // Para outros tipos, SizeQuantity vai preencher, então [] é ok

        return {
          product: productData,
          dataProduct: {
            ...prevState.dataProduct, // Mantém outras propriedades de dataProduct
            listSizes: initialListSizes, // Inicializa listSizes para o novo produto
          },
          calcPrice: "",
          // ... outros resets de estado
        };
      });
    } catch (error) {
      console.error("Erro ao carregar o produto:", error);
      toast.error("Erro ao carregar o produto.");
      this.setState({ product: {}, dataProduct: { listSizes: [] }, calcPrice: "" }); // Reseta em caso de erro
    }
  };


  // getProductsType = async () => {
  //   const { dataRequest } = this.props;
  //   const { idProduto } = dataRequest;
  //   try {
  //     const data = await getDmService(`/Produto/GetTipo/?id=${dataRequest.idGrupo}`);
  //     this.setState({
  //       data
  //     });
  //   } catch (error) {
  //     console.log(error)
  //   }
  // };
  saveStep = (stepData, stepName) => {
    // stepData pode ser { listSizes: [...] }, { briefingText: '...' }, etc.
    this.setState(prevState => {
      let newPendingStep = prevState.pendingStep;
      let newPendingStepBriefing = prevState.pendingStepBriefing;

      // Lógica para atualizar pendingStep e pendingStepBriefing
      if (stepName === "sizeQuantityStep") {
        // Se o passo de quantidade/tamanho foi concluído (ou ignorado para texto)
        newPendingStep = !stepData.listSizes || stepData.listSizes.length === 0;
      } else if (stepName === "briefing") {
        // Se o briefing foi preenchido
        const hasText = stepData.listSizes && stepData.listSizes.length > 0 && stepData.listSizes[0].texto && stepData.listSizes[0].texto.trim() !== '<p></p>';
        newPendingStepBriefing = !hasText;
      }
      // ... adicione lógica para outros steps se necessário

      return {
        dataProduct: {
          ...prevState.dataProduct,
          ...stepData, // Mescla os dados do passo no dataProduct
        },
        pendingStep: newPendingStep,
        pendingStepBriefing: newPendingStepBriefing,
      };
    });
  };

  updatePrice = async () => {
    const { dataProduct, listRequest } = this.state;
    const { dataFilters, listSizes } = dataProduct;
    const price = dataFilters && dataFilters.precoReferencia ? dataFilters.precoReferencia : 0;
    const values = listSizes && listSizes.length ? listSizes : listRequest && listRequest.length ? listRequest : [];
    const existOthers = values.length && Object.prototype.hasOwnProperty.call(values[0], 'otherValues');
    const typeGlass = !existOthers ? values.length && Object.prototype.hasOwnProperty.call(values[0], 'sizesInputed')
      : values.length && Object.prototype.hasOwnProperty.call(values[0].otherValues, 'sizesInputed');
    let valueWidth = 0;
    let valueQuantity = 0;
    const unitMensurement = dataFilters && dataFilters.unidadeMedida ? dataFilters.unidadeMedida : 0;
    let valueHeigth = 0;
    let detalhes = [];
    let formData = {};
    if (values.length && !typeGlass) {
      for (const item of values) {
        const obj = Object.prototype.hasOwnProperty.call(item, 'otherValues') ? item.otherValues : item;
        valueQuantity = parseInt(obj.amountSize, 10);
        if (obj.value && obj.value.isAlturaVariavel) {
          valueHeigth = parseFloat(obj.heightSize);
          valueWidth = parseFloat(obj.widthSize);
        } else if (!obj.isAlturaVariavel) {
          const existValue = Object.prototype.hasOwnProperty.call(obj, "value");
          valueHeigth = existValue ? parseFloat(obj.value.altura) : parseFloat(obj.heightSize)
          valueWidth = existValue ? parseFloat(obj.value.largura) : parseFloat(obj.widthSize);
        } else {
          valueHeigth = parseFloat(obj.heightSize);
          valueWidth = parseFloat(obj.widthSize);
        }
        detalhes.push({
          Quantidade: valueQuantity,
          Altura: valueHeigth,
          Largura: valueWidth
        })
      }
      formData = {
        UnidadeMedida: unitMensurement,
        ValorReferencia: price,
        Detalhes: detalhes
      }
    }
    if (typeGlass) {
      detalhes = [];
      for (const item of values) {
        const obj = Object.prototype.hasOwnProperty.call(item, 'otherValues') ? item.otherValues : item;
        detalhes.push({
          Largura: parseFloat(obj.sumSizes.widthProp),
          Altura: parseFloat(obj.sumSizes.heightProp),
          Quantidade: parseInt(obj.quantityPerModel, 10)
        })
      }
      formData = {
        UnidadeMedida: unitMensurement,
        ValorReferencia: price,
        Detalhes: detalhes
      }
    }
    if (values.length) {
      try {
        const result = await insertDmService('/Pedido/CalcValorPedidoAgencia/', formData);
        this.setState({
          calcPrice: result.valorFormatado,
          finalPrice: parseFloat(result.valor)
        })
      } catch (error) {
        console.log(error);
        this.setState({
          calcPrice: "",
          finalPrice: parseFloat(0)
        })
      }
    }
  }

  uploadFileReferences = async idItem => {
    const { dataProduct } = this.state;

    await Promise.all(
      dataProduct.uploads.map(async file => {
        const data = new FormData();
        data.append('file', file);
        await insertDmService(`/Pedido/UploadArquivoReferencia/?IdItemPedido=${idItem}`, data);
      }),
    );
  };

  updateToCart = async () => {
    await this.addToCart();
  }

  handleCreateTextChange = (value) => {
    this.setState({ createText: value !== undefined && value !== null ? Number(value) : null });
  };

  addToCart = async () => {
    const { history, match } = this.props;
    const { params, path } = match
    const {
      dataProduct,
      finalPrice,
      dataRequest,
      listRequest,
      isKit,
      createText,
      product
    } = this.state;
    const {
      idProuto,
      idMaterial,
      idDetalhe,
      LocalAplicacao,
    } = dataRequest;
    const {
      variableSave,
      dataFilters,
      listSizes,
      aplicationSave
    } = dataProduct;

    this.setState({ disabledButtonCart: true })
    const idProduct = dataFilters ? dataFilters.id : idProuto;
    const idMateria = dataFilters ? dataFilters.idMaterial : idMaterial;
    const idDetail = dataFilters ? dataFilters.idDetalhe : idDetalhe || 0;
    const idApplication = (aplicationSave && aplicationSave.id) || (dataFilters ? dataFilters.listaAplicacoes[0].id : LocalAplicacao);
    const validat = true;
    // const labelVariable = variableSave && variableSave.value ? variableSave.value : "";
    const labelVariable = variableSave && (variableSave.value ? variableSave.value : variableSave.label ? variableSave.label : "");
    const isGlass = labelVariable === "unico" || labelVariable === "fracionado" || labelVariable === "sequencial";
    const details = [];
    const formData = [];
    const listSizesInputed = listSizes && listSizes.length ? listSizes : listRequest || []
    const existOutraAplicacao = Object.prototype.hasOwnProperty.call(dataProduct, "requiredComplementSave");
    if (isKit) {
      listSizes.forEach((item, idx) => {
        const temp = dataRequest && dataRequest.detalhes && dataRequest.detalhes.length > idx ? dataRequest.detalhes[idx] : {};
        details.push({
          Id: temp.id || 0,
          Quantidade: item.produto.quantidadeMinima || (temp.quantidade || null),
          Briefing: item.texto ? item.texto : (temp.briefing || null),
          IdProdutoAgencia: item.produto.id,
          // TamanhoDescritivo: testExist ? item.otherValues.sizesInputed.descriptionSize : (item.sizesInputed && Object.prototype.hasOwnProperty.call(item.sizesInputed, "descriptionSize")) ? item.sizesInputed.descriptionSize : (temp.tamanhoDescritivo || null),
          Tamanhos: []
        });
        formData.push({
          IdProdutoAgencia: item.produto.id,
          IdMaterial: item.produto.idMaterial,
          IdDetalhe: item.produto.idDetalhe,
          LocalAplicacao: idApplication || (dataRequest.localAplicacao || 0),
          VariaveisAplicacao: variableSave && variableSave.id ? variableSave.id : (dataRequest.variaveisAplicacao || 0),
          Detalhes: details,
          ValorTotal: finalPrice || dataRequest.valorTotal,
          IdItemPedido: dataRequest.idItemPedido,
          OutraAplicacao: existOutraAplicacao ? dataProduct.requiredComplementSave : null
        });
      });
      const idEdit = path === "/agencia/pedido/:id" && params.id > 0;
      try {
        let data = null;
        if (!idEdit) {
          data = await insertDmService('/Pedido/AdicionaKitCarrinho', formData)
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(data.idItemPedido);
          }
        }
        else {
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(dataRequest.idItemPedido);
          }
          data = await updateDmService('/Pedido/EditaDetalheItemPedidoAgencia', params.id, formData);
        }
        if (idEdit) {
          await toast.success("O pedido foi atualizado com sucesso.");
          await history.goBack()
        } else {
          await toast.success("O pedido foi realizado com sucesso.");
          await history.push('/carrinho')
        }
      } catch (error) {
        this.setState({ disabledButtonCart: false })
        this.errorHandler(error);
        console.log(error);
      }
    } else {
      if (isGlass) {
        // Capture global briefing text if available
        const globalBriefing = listSizesInputed.length > 0 && listSizesInputed[0].texto ? listSizesInputed[0].texto : null;

        listSizesInputed.forEach((item, idx) => {
          const temp = dataRequest && dataRequest.detalhes && dataRequest.detalhes.length > idx ? dataRequest.detalhes[idx] : {};
          let list = Object.prototype.hasOwnProperty.call(item, "otherValues") ? item.otherValues.sizesInputed : item.sizesInputed;
          if (typeof list === 'undefined')
            list = temp.tamanhos;
          const quantiyPerModel =
            item.otherValues ?
              (item.otherValues.quantityPerModel
                ? parseInt(item.otherValues.quantityPerModel, 10) : 1)
              : item.quantityPerModel ? item.quantityPerModel : 1;
          const numberOfLeaves = list.length || 0;
          const brief = item.texto || globalBriefing; // Use item text OR global briefing
          const detailItem = [];
          list.forEach((element, idx2) => {
            const tam = temp && temp.tamanhos ? temp.tamanhos[idx2] : {};
            const { heightProp, widthProp } = element
            const propHeight = heightProp || tam.altura;
            const propWidth = widthProp || tam.largura;
            // console.log("y", dataProduct.dataFilters.listaTamanhos)
            detailItem.push({
              Altura: parseInt(propHeight, 10),
              Largura: parseInt(propWidth, 10),
              // IdTamanho: dataProduct.dataFilters.listaTamanhos[idx2].id,
              Id: temp.id ? temp.id : item.value && item.value.id ? item.value.id : (tam ? tam.id : 0),
            })
          });
          details.push({
            Quantidade: quantiyPerModel || (temp.quantidade || null),
            NroFolhas: numberOfLeaves || (temp.nroFolha || null),
            Id: temp.id || 0,
            Briefing: brief || (temp.briefing || null),
            Tamanhos: detailItem
          });
        });
      }
      else {
        // Capture global briefing text if available (from first item or other source)
        const globalBriefing = listSizes.length > 0 && listSizes[0].texto ? listSizes[0].texto : null;

        listSizes.forEach((item, idx) => {
          const existOtherValues = Object.prototype.hasOwnProperty.call(item, "otherValues");
          const testExist = existOtherValues && Object.prototype.hasOwnProperty.call(item.otherValues, "sizesInputed") ? Object.prototype.hasOwnProperty.call(item.otherValues.sizesInputed, "descriptionSize") : !validat
          let Altura = item.value && item.value.altura ? item.value.altura : typeof item.otherValues === 'undefined' ? 0 : parseFloat(item.otherValues.heightSize);
          let Largura = item.value && item.value.largura ? item.value.largura : typeof item.otherValues === 'undefined' ? 0 : parseFloat(item.otherValues.widthSize);
          console.log("item", item)
          if (typeof item.heightSize !== 'undefined')
            Altura = parseFloat(item.heightSize);
          else if (existOtherValues && item.otherValues.heightSize)
            Altura = parseFloat(item.otherValues.heightSize);
          if (typeof item.widthSize !== 'undefined')
            Largura = parseFloat(item.widthSize);
          else if (existOtherValues && item.otherValues.widthSize)
            Largura = parseFloat(item.otherValues.widthSize);
          const quantityPerSize =
            item.otherValues && item.otherValues.amountSize
              ? parseInt(item.otherValues.amountSize, 10)
              : item.amountSize ? parseInt(item.amountSize, 10)
                : null;
          const existingDetailFromRequest = (dataRequest && dataRequest.detalhes && dataRequest.detalhes.length > idx) ? dataRequest.detalhes[idx] : null; // Se não encontrar ou estiver fora dos limites, defina como null
          const temp = existingDetailFromRequest || {};
          const descriptionSize = item.otherValues && item.otherValues.sizesInputed ? item.otherValues.sizesInputed.descriptionSize : "";
          const brief = item.texto || globalBriefing; // Use item text OR global briefing
          details.push({
            id: temp.id || 0,
            quantidade: quantityPerSize !== null ? quantityPerSize : (temp.quantidade || 0),
            tamanhoDescritivo: temp.tamanhoDescritivo || descriptionSize || "",
            Briefing: brief || (temp.briefing || null),
            tamanhos: [
              {
                idTamanho: temp.tamanhos && temp.tamanhos.length > 0 ? temp.tamanhos[0].idTamanho : (item.value && item.value.id ? item.value.id : 0),
                quantidade: quantityPerSize !== null ? quantityPerSize : (temp.tamanhos && temp.tamanhos.length > 0 ? temp.tamanhos[0].quantidade : 0),
                largura: Largura !== 0 ? Largura : (temp.tamanhos && temp.tamanhos.length > 0 ? temp.tamanhos[0].largura : 0),
                altura: Altura !== 0 ? Altura : (temp.tamanhos && temp.tamanhos.length > 0 ? temp.tamanhos[0].altura : 0),
              }
            ]
          }
          )
        })
      }
      // eslint-disable-next-line no-shadow
      const targetPedidoId = new URLSearchParams(window.location.search).get('targetPedidoId') || sessionStorage.getItem('targetPedidoId');

      const formData = {
        IdPedido: targetPedidoId ? Number(targetPedidoId) : null,
        IdProdutoAgencia: idProduct || dataRequest.idProduto,
        IdMaterial: idMateria,
        IdDetalhe: idDetail,
        LocalAplicacao: idApplication || (dataRequest.localAplicacao || 0),
        VariaveisAplicacao: variableSave && variableSave.id ? variableSave.id : (dataRequest.variaveisAplicacao || 0),
        Detalhes: details,
        ValorTotal: finalPrice || dataRequest.valorTotal,
        IdItemPedido: dataRequest.idItemPedido,
        OutraAplicacao: existOutraAplicacao ? dataProduct.requiredComplementSave : null,
        CriarTexto: createText !== undefined && createText !== null ? Number(createText) : null
      }
      const idEdit = path === "/agencia/pedido/:id" && params.id > 0;
      console.log("formData", formData);
      try {
        let data = null;
        if (!idEdit) {
          data = await insertDmService('/Pedido/AdicionaProdutoAgenciaCarrinho', formData)
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(data.idItemPedido);
          }
        }
        else {
          if (dataProduct.uploads && dataProduct.uploads.length > 0) {
            await this.uploadFileReferences(dataRequest.idItemPedido);
          }
          data = await updateDmService('/Pedido/EditaDetalheItemPedidoAgencia', params.id, formData);
        }
        if (idEdit) {
          await toast.success("O pedido foi atualizado com sucesso.");
          await history.goBack()
        } else if (targetPedidoId) {
          sessionStorage.removeItem('targetPedidoId');
          await toast.success(`Produto adicionado ao Pedido #${targetPedidoId} com sucesso.`);
          await history.push(`/admin/agencia/pedido/${targetPedidoId}`);
        } else {
          await toast.success("O pedido foi realizado com sucesso.");
          await history.push('/carrinho')
        }
      } catch (error) {
        this.setState({ disabledButtonCart: false })
        this.errorHandler(error);
        console.log(error);
      }
    }
  }

  errorHandler = err => {
    const existError = Object.prototype.hasOwnProperty.call(err, "error");
    const existResponse = existError ? Object.prototype.hasOwnProperty.call(err.error, "response") : false;
    const existData = existResponse ? Object.prototype.hasOwnProperty.call(err.error.response, "data") : false;
    if (err.error && existError && existResponse && existData && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';
      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } if (err.message)
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  // REMOVIDO: Esta função não é mais necessária, pois a lógica de isFinished
  // e visibilidade será tratada diretamente no render, passando as props para o componente filho.
  // handleSizeQuantityStepStatus = () => {
  //   const { product } = this.state; // Lendo do estado
  //   const { saveStep } = this.props; // Lendo das props
  //   const isProductTipoUsoText = (product && product.tipoUso && product.tipoUso.includes("Texto"));
  //   if (isProductTipoUsoText) {
  //     saveStep("sizeQuantityStep", true);
  //   } else {
  //     // saveStep("sizeQuantityStep", false);
  //   }
  // };
  renderCreateText = () => {
    const { createText } = this.state;
    return (
      <React.Fragment>
        <div className='radio-input'>
          <p className='color-red'><b>Este pedido envolve a criação ou revisão de texto?</b></p>
          <div className="inline-radio">
            <RadioButtonGroup
              legendText="Radio button heading"
              name="CriarTexto"
              valueSelected={createText}
              onChange={value => this.setState({ createText: Number(value) })}
            >
              <RadioButton
                value={1}
                labelText="Sim"
                id="radio-1"
              />
              <RadioButton
                value={0}
                labelText="Não"
                id="radio-2"
              />
            </RadioButtonGroup>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const {
      product, // Este 'product' vem de this.state
      dataProduct,
      disabledButtonCart,
      calcPrice,
      dataRequest,
      nivel,
      idStatusPedido,
      isCarrinho,
      sizeOK,
      pendingStep,
      pendingStepBriefing,
      isKit,
      excluido,
    } = this.state;
    const { match, history } = this.props;
    const { path } = match;

    // Lógica para controlar a visibilidade e o status isFinished do SizeQuantity/KitProducts
    let isProductTipoUsoText = false;
    if (product && product.tipoUso) { // Verifica se product e product.tipoUso existem
      isProductTipoUsoText = product.tipoUso.includes("Texto");
    }

    const hideSizeQuantityOrKit = isProductTipoUsoText; // Se tipoUso for "Texto", escondemos
    // Se tipoUso for "Texto", o passo é considerado finalizado (true).
    // Caso contrário, usa a lógica existente (pendingStep ? false : (sizeQuantiyOk || existRequest)).

    const urlId = match.params.id;
    const validate = true;
    const uploadedOk = dataProduct.dataFilters && dataProduct.dataFilters.uploadReferencia
      ? (dataProduct.uploads ? validate : !validate)
      : validate;
    const existSizes = dataProduct && Object.prototype.hasOwnProperty.call(dataProduct, 'listSizes')
      && dataProduct.listSizes.length ? validate : !validate;
    const productOk = dataProduct && dataProduct.productSave && Object.keys(dataProduct.dataFilters).length ? validate : !validate
    const sizeQuantiyOk = dataProduct && existSizes && sizeOK ? validate : !validate;
    const validatProduct = dataProduct && dataProduct.found ? !validate : validate;
    const existDatafilters = Object.prototype.hasOwnProperty.call(dataProduct, 'dataFilters');
    const briefingOptional = existDatafilters ? dataProduct.dataFilters.briefing : validate;
    const textInBriefing = (dataProduct.listSizes && dataProduct.listSizes.length > 0 && dataProduct.listSizes[0].texto ? validate : !validate);
    const briefingOk = !briefingOptional || textInBriefing
    const briefingValidate = briefingOk || !briefingOptional;
    const blockButton = sizeQuantiyOk
      && productOk
      && briefingValidate
      && uploadedOk
      && !disabledButtonCart;
    const existRequest = path === "/agencia/pedido/:id" && Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    const blockedUpload = existRequest ? false : briefingValidate && existSizes ? !validate : validate;
    const loadedComponents = existRequest || path !== "/agencia/pedido/:id";
    const disableSize = existRequest ? false : validatProduct;
    // const verifyDisable = sizeQuantiyOk ? !validate : validate;
    // const disableBriefing = isCarrinho ? false : verifyDisable;
    const disable = !isCarrinho && !(([Administrador, Interno].indexOf(nivel) > -1) || ([Consultor, Supervisor].indexOf(nivel) > -1 && [Devolvido, Triagem].indexOf(idStatusPedido) > -1));
    const tempDisable = !([Administrador, Interno].indexOf(nivel) > -1 || [Administrador, Consultor, Supervisor, Interno].indexOf(nivel) > -1) && [Devolvido, Triagem].indexOf(idStatusPedido) > -1;
    const userValues = JSON.parse(localStorage.getItem("user"));
    const permissionForAgency = userValues.agencia;
    const permission = !isCarrinho && !permissionForAgency;

    const isSizeQuantityStepFinished = isProductTipoUsoText ? true : (pendingStep ? false : (sizeQuantiyOk || existRequest));
    const targetPedidoId = new URLSearchParams(window.location.search).get('targetPedidoId') || sessionStorage.getItem('targetPedidoId');

    return (
      <div>
        <Breadcrumb
          title={product.name || "Detalhe do item"}
          description={product.description}
          renderLeft={(
            <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          )}
        />
        <div className="center-box">
          {targetPedidoId && (
            <div style={{ marginBottom: 20 }}>
              <Notification
                kind="info"
                title="Adicionando Produto ao Pedido Existente"
                subtitle={`Você está configurando este produto para ser inserido diretamente no Pedido #${targetPedidoId}. Ao finalizar, o item será gravado no pedido e você retornará a ele.`}
              />
            </div>
          )}
          {loadedComponents && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-12">
                <SelectedProducts
                  urlId={urlId}
                  product={product}
                  {...this.props}
                  saveStep={this.saveStep}
                  dataRequest={dataRequest}
                  dataProduct={dataProduct}
                  disabled={false}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-12">
                {/* Renderiza KitProducts ou SizeQuantity, controlando visibilidade e isFinished */}
                {isKit && product.name.includes("Kit Merchan") ? (
                  <KitProducts
                    {...this.props}
                    dataProduct={dataProduct}
                    saveStep={this.saveStep}
                    isFinished={isSizeQuantityStepFinished} // Passa o status de finalizado
                    disabledCard={![Criacao, Administrador, Interno].includes(nivel) && (disableSize || disable || permission)}
                    dataRequest={dataRequest}
                    style={hideSizeQuantityOrKit ? { display: 'none' } : {}} // Esconde se tipoUso for "Texto"
                  />
                ) : (
                  <SizeQuantity
                    {...this.props}
                    dataProduct={dataProduct}
                    saveStep={this.saveStep}
                    isFinished={isSizeQuantityStepFinished} // Passa o status de finalizado
                    disabledCard={![Criacao, Administrador, Interno].includes(nivel) && (disableSize || disable || permission)}
                    dataRequest={dataRequest}
                    style={hideSizeQuantityOrKit ? { display: 'none' } : {}} // Esconde se tipoUso for "Texto"
                  />
                )}
              </div>
              <div className="bx--col-xs-12 bx--col-md-12">
                <BriefingRequestProduct
                  {...this.props}
                  urlId={urlId}
                  dataProduct={dataProduct}
                  isFinished={pendingStepBriefing ? false : (textInBriefing || existRequest)}
                  saveStep={this.saveStep}
                  // disabledCard={disableBriefing || disable || permission}
                  disabledCard={tempDisable}
                  dataRequest={dataRequest}
                  isKit={isKit}
                  onCreateTextChange={this.handleCreateTextChange}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-12">
                {/* UploadReference continua com renderização condicional (null) */}
                {product && (!product.tipoUso || !product.tipoUso.includes("Texto")) ? (
                  <UploadReference
                    {...this.props}
                    dataProduct={dataProduct}
                    saveStep={this.saveStep}
                    disabledCard={blockedUpload || disable || permission}
                    dataRequest={dataRequest}
                  />
                ) : null}
              </div>
              <div className="bx--col-xs-12  v-md-margin">
                {existRequest ? (
                  <div>
                    {(!excluido && (isCarrinho || (([Administrador, Interno].indexOf(nivel) > -1) || ([Consultor, Supervisor].indexOf(nivel) > -1 && [Devolvido].indexOf(idStatusPedido) > -1))) && !permission) && (
                      <button
                        type="button"
                        className="bx--btn btn-full btn-secondary-color"
                        disabled={pendingStep}
                        onClick={() => this.updateToCart()}
                      >
                        ATUALIZAR PEDIDO
                        {` ${calcPrice}`}
                      </button>
                    )}
                  </div>
                ) : (
                  <Button
                    className="bx--btn btn-full btn-secondary-color"
                    onClick={() => this.addToCart()}
                    disabled={!blockButton}
                  >
                    {targetPedidoId ? `ADICIONAR AO PEDIDO #${targetPedidoId}` : `ADICIONAR AO CARRINHO ${calcPrice}`}
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default Edit;



// WEBPACK FOOTER //
// ./src/screens/client/agency/requests/Edit.js